import "~/scss/page-templates/exhibitorsLanding.scss";

import _ from "underscore";
import { getElementHeight } from "~/js/lib/utils";

console.log('exhibitorsLanding.ts');

const exhibitorsSectionsEl:NodeListOf<HTMLElement>|null = document.querySelectorAll('.section');

let exhibitorsSections:any[] = [];

console.log('exhibitorsSectionsEl:', exhibitorsSectionsEl);

if( exhibitorsSectionsEl !== null ) {
  for( let i=0; i<exhibitorsSectionsEl.length; i++ ) {
    let copyContent:HTMLElement|null = exhibitorsSectionsEl[i].querySelector('.exhibitors-content');
    let imageContentContainer:HTMLElement|null = exhibitorsSectionsEl[i].querySelector('.exhibitors-image-content');
    let imageContent:HTMLElement|null = exhibitorsSectionsEl[i].querySelector('.exhibitors-image-content .exhibitors-image-img');

    console.log('copyContent:', copyContent);
    console.log('imageContent:', imageContent);

    if( copyContent !== null && imageContent !== null ) {
      let header:HTMLElement|null = copyContent.querySelector('.exhibitors-content__header-container');
      let copy:HTMLElement|null = copyContent.querySelector('.exhibitors-content__copy');
      let buttons:HTMLElement|null = copyContent.querySelector('.exhibitors-content__buttons-list');

      let copyContentHeight = 0;
      if( header ) {
        copyContentHeight += header.clientHeight;
      }

      if( copy ) {
        copyContentHeight += copy.clientHeight;
      }

      if( buttons ) {
        copyContentHeight += buttons.clientHeight;
      }

      exhibitorsSections.push(
        {
          copyContent: copyContent,
          copyContentHeight: copyContentHeight,
          imageContentContainer: imageContentContainer,
          imageContent: imageContent,
          imageContentOriginalWidth: 1060,
          imageContentOriginalHeight: 800
        }
      )
    }
  }
}


function resize() {
  // console.log('resize()');
  let browserWidth = window.innerWidth;

  let minHeight = 450;
  if( browserWidth >= 1720 ) {
    minHeight = 350;
  } else if( browserWidth >= 1536 ) {
    minHeight = 350;
  } else if( browserWidth >= 1280 ) {
    minHeight = 325;
  } else if( browserWidth >= 1024 ) {
    minHeight = 300;
  } else if( browserWidth >= 768 ) {
    minHeight = 300;
  }

  // console.log(exhibitorsSections);
  for( let i=0; i<exhibitorsSections.length; i++ ) {
    if( window.innerWidth >= 768 ) {
      // console.log(exhibitorsSections[i].copyContent);
      let header:HTMLElement|null = exhibitorsSections[i].copyContent.querySelector('.exhibitors-content__header-container');
      let copy:HTMLElement|null = exhibitorsSections[i].copyContent.querySelector('.exhibitors-content__copy');
      let buttons:HTMLElement|null = exhibitorsSections[i].copyContent.querySelector('.exhibitors-content__buttons-list');

      let copyContentHeight = 0;
      if( header ) {
        let headerHeight = getElementHeight(header);
        // console.log('headerHeight:', headerHeight);
        copyContentHeight += headerHeight !== null ? headerHeight : 0;
      }

      if( copy ) {
        let copyHeight = getElementHeight(copy);
        // console.log('copyHeight:', copyHeight);
        copyContentHeight += copyHeight !== null ? copyHeight : 0;
      }

      if( buttons ) {
        let buttonsHeight = getElementHeight(buttons);
        // console.log('buttonsHeight:', buttonsHeight);
        copyContentHeight += buttonsHeight !== null ? buttonsHeight : 0;
      }

      // let copyHeight = exhibitorsSections[i].copyContent.clientHeight;

      if( copyContentHeight < minHeight ) {
        copyContentHeight = minHeight;
      }

      let height = copyContentHeight;
      if( height < exhibitorsSections[i].imageContentContainer.clientHeight ) {
        // height = exhibitorsSections[i].imageContentContainer.clientHeight;
      }

      let ratioY:number = height / exhibitorsSections[i].imageContentOriginalHeight;

      // console.log('height:', height);
      // console.log('ratioY:', ratioY);

      let width = Math.round(ratioY * exhibitorsSections[i].imageContentOriginalWidth);
      // console.log('new width:', width);
      // console.log('imageContentContainer.width:', exhibitorsSections[i].imageContentContainer.clientWidth);
      if( width < exhibitorsSections[i].imageContentContainer.clientWidth ) {
        // width = exhibitorsSections[i].imageContentContainer.clientWidth;
      }
      // console.log('width:', width);

      exhibitorsSections[i].imageContent.style.width = width+'px';
    } else {
      exhibitorsSections[i].imageContent.style.width = '100%';
    }

    // break;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    resize();
  }, 100);
  
});

let resizeThrottled = _.throttle(() => {
  resize();
}, 200);

window.addEventListener('resize', () => {
  resizeThrottled();
})
